// 한국 공휴일 데이터 (2025 ~ 2026)
// 추후 연도가 필요하면 아래 배열에 추가하면 달력/투입시간 화면에 자동 반영됩니다.
export interface KoreanHoliday {
  date: string
  name: string
}

export const KOREAN_HOLIDAYS: KoreanHoliday[] = [
  { date: "2025-01-01", name: "신정" },
  { date: "2025-01-28", name: "설날 연휴" },
  { date: "2025-01-29", name: "설날" },
  { date: "2025-01-30", name: "설날 연휴" },
  { date: "2025-03-01", name: "삼일절" },
  { date: "2025-03-03", name: "삼일절 대체공휴일" },
  { date: "2025-05-05", name: "어린이날" },
  { date: "2025-05-06", name: "부처님오신날 대체공휴일" },
  { date: "2025-06-06", name: "현충일" },
  { date: "2025-08-15", name: "광복절" },
  { date: "2025-10-03", name: "개천절" },
  { date: "2025-10-06", name: "추석 연휴" },
  { date: "2025-10-07", name: "추석" },
  { date: "2025-10-08", name: "추석 연휴" },
  { date: "2025-10-09", name: "한글날" },
  { date: "2025-12-25", name: "성탄절" },
  { date: "2026-01-01", name: "신정" },
  { date: "2026-02-16", name: "설날 연휴" },
  { date: "2026-02-17", name: "설날" },
  { date: "2026-02-18", name: "설날 연휴" },
  { date: "2026-03-02", name: "삼일절 대체공휴일" },
  { date: "2026-05-05", name: "어린이날" },
  { date: "2026-05-25", name: "부처님오신날" },
  { date: "2026-06-03", name: "전국동시지방선거" },
  { date: "2026-07-17", name: "제헌절" },
  { date: "2026-09-24", name: "추석 연휴" },
  { date: "2026-09-25", name: "추석" },
  { date: "2026-10-05", name: "추석 연휴" },
  { date: "2026-10-09", name: "한글날" },
  { date: "2026-12-25", name: "성탄절" },
]

const HOLIDAY_MAP = new Map<string, string>()
KOREAN_HOLIDAYS.forEach((holiday) => {
  HOLIDAY_MAP.set(holiday.date, holiday.name)
})

/** 지정한 날짜(YYYY-MM-DD)가 공휴일인지 여부 */
export function isHoliday(dateStr: string): boolean {
  return HOLIDAY_MAP.has(dateStr)
}

/** 공휴일 이름 — 공휴일이 아니면 빈 문자열 */
export function getHolidayName(dateStr: string): string {
  return HOLIDAY_MAP.get(dateStr) ?? ""
}

/** 날짜 객체를 YYYY-MM-DD 문자열로 변환 (타임존 영향 없이 로컬 기준) */
export function toDateKey(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

/** 공휴일 배열에 등록된 날짜 문자열 목록 (기존 includes 방식 호환용) */
export const KOREAN_HOLIDAY_DATES: string[] = KOREAN_HOLIDAYS.map((h) => h.date)
